/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-bandage',['require','underscore','jquery','activities/scenario-activity','activities/activity-backblow'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var ActivityBackBlow = require('activities/activity-backblow');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityBandage = ActivityBackBlow.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    doneBtn: null,
    minPressCount: 1,
    correctPressCount: 0,
    totalBlows: 0,
    totalDrops: 0,
    dropMatch: 0,
    disableAfterReachingLimit: false,
    isInfant: false,
    bvmMC: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ActivityBackBlow.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      if (this.doneBtn)
      {
        this.doneBtn.off('click');
        this.doneBtn.addClass('disabled');
      }

      ActivityBackBlow.prototype.onBeforeDestroy.apply(this);
    },

    setupApplyBandage: function()
    {
      this.playAudio('audio', this.currentPhase);

      if (this.currentPhase.startItem === 'dressing')
        this.dropMatch = 0;
      else if (this.currentPhase.startItem === 'bandage')
        this.dropMath = 1;

      this.totalDrops = 0;

      //<ContentObject id="positionHolder.panel" className="ThrustChestPositionPanel_Infant" />
      ////console.log('pos', this.isInfant);

      this.handPanel = this.currentScene.find('[data-mc=panelHolder]');//new DragPanel(this.mc.panelHolder.panel);
      _.each(this.handPanel.find('.airway-hand'), function(hand) {
        $(hand).data().origin = $(hand).position();
      });

      this.dragItems = Draggable.create(this.handPanel.find('.airway-hand'), {
        bounds: '[data-role=scenario-activity]',
        onPress: this.onStartDrag,
        onPressParams: [this],
        onDragEnd: this.onEndDrag,
        onDragEndParams: [this],
        //force3D: false,
        type: 'top, left'
      });

      //var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');
      this.totalDrops = this.dropPanel.find('.activity-drop').length;

      /*this.handPanel.find('.airway-hand').draggable({
        containment: '[data-role=scenario-activity]',
        cursor: 'move',
        scroll: false,
        //start: $.proxy(this.onStartDrag, this),
        revert: $.proxy(this.onIncorrectDrop, null, this),
        //revert: 'invalid'
      });

      var self = this;
      this.dropPanel = this.currentScene.find('[data-mc=drop_items]');

      _.each(this.dropPanel.find('.activity-drop'), function(dropDiv) {
        var $dropItem = $(dropDiv);
        var $validAccept = (self.currentPhase['universal']) ? '.activity-drag' : $dropItem.attr('data-mc').replace('drop', 'item');
        self.totalDrops++;

        $dropItem.droppable({
          accept: $.proxy(self.checkDropAccept, self, $validAccept, $dropItem),
          hoverClass: 'over',
          greedy: false,
          drop: $.proxy(self.onCorrectDrop, self, $dropItem)
        });
      });*/
    },

    onEndDrag: function(self)
    {
      var $drag = $(this.target);
      var $cDrop = (self.currentPhase['universal']) ? self.currentScene.find('.activity-drag') : self.currentScene.find('[data-mc=' + $drag.attr('data-mc').replace('item', 'drop') + ']');

      if ($drag.data().origin && Math.abs($drag.data().origin.left - $drag.position().left) <= 150) // still in drop pen
      {
        self.revertDrag($drag);
      }
      else if ($cDrop.length > 0 && Draggable.hitTest($drag, $cDrop, '70%') && $cDrop.attr('data-mc') === 'drop' + self.dropMatch.toString()) // correct
      {
        self.onCorrectDrop.apply(self, [$cDrop, $drag]);
      }
      else // incorrect
      {
        self.onIncorrectDrop(self, $drag);
      }
      //self.onIncorrectDrop.apply($(this.target), self, true);
      //self.onIncorrectDrop($(this.target), true);
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      this.dropMatch++;
      $drag.empty();
      this.currentScene.find('.bandage-asset').attr('data-frame', 'f' + this.dropMatch);

      Draggable.get($drag).disable();
      $drag.addClass('is-correct');
      $dropItem.addClass('is-correct');
      //$drag.draggable.draggable('disable');
      this.attempt = 0;

      if (this.dropMatch === this.totalDrops - 1)
        this.playAudio('audio-feedback-tie-correct', this.phases[this.phaseIndex], this.tieKnot);

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.disableDrags();
        this.playAudio('final-feedback', this.phases[this.phaseIndex - 1], this.finish, this.killSomeTime);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    tieKnot: function()
    {
      this.playAudio('tie-knot', this.phases[this.phaseIndex]);
    },

    onIncorrectDrop: function($scope, $drag)
    {
      $scope.scoreValue--;
      this.downgradePerformance();
      $scope.attempt++;
      if ($scope.attempt >= $scope.maxAttempts)
      {
        var __drag = $scope.currentScene.find('[data-mc=item' + $scope.dropMatch + ']').empty();
        $scope.disableDrags(__drag);
        $scope.dropMatch++;
        $scope.currentScene.find('.bandage-asset').attr('data-frame', 'f' + this.dropMatch);
        $scope.attempt = 0;
        if ($scope.dropMatch === $scope.totalDrops) // done
        {
          $scope.disableDrags();
          $scope.revertDrag($drag);
          $scope.playAudio('final-feedback-incorrect', $scope.phases[$scope.phaseIndex], $scope.finish, $scope.killSomeTime);
          //return true;
          return;
        }
        else
        {
          $scope.revertDrag($drag);
        }
      }
      else
      {
        $scope.revertDrag($drag);
        //$drag.returnToOrigin({time: 0.25, transition: 'easeoutquad'});
      }

      if ($scope.dropMatch === $scope.totalDrops - 1)
        $scope.playAudio('tie-knot', $scope.phases[$scope.phaseIndex]);
      else
        $scope.playAudio('audio-feedback-incorrect', $scope.currentPhase);
      return true;
    },

    checkDropAccept: function($valid, $drop, $drag)
    {
      //console.log('check drop', $valid, ('item' + this.dropMatch.toString()), $drag.attr('data-mc'));
      if ($drop.attr('data-mc') === 'drop' + this.dropMatch.toString() &&
          $drag.attr('data-mc') === $valid &&
          'item' + this.dropMatch.toString() === $valid)
      {
        //console.log('match');
        return true;
      }

      return false;
    },

    allComplete: function()
    {
      //console.log('check complete', this.totalDrops);
      if (this.dropMatch >= this.totalDrops || this.isInfant)
        return true;

      return false;
    },

    killSomeTime: function()
    {
      //var $timer:Timer = new Timer(3000);
      //$timer.addEventListener(TimerEvent.TIMER, this.onKilledTime);
      //$timer.start();
      setTimeout($.proxy(this.onKilledTime, this), 2000);
    },

    onKilledTime: function($e)
    {
      //$e.target.removeEventListener(TimerEvent.TIMER, this.onKilledTime);

      this.finish();
    },

    evaluatePerformance: function()
    {
      //console.log('eval perf', this.isInfant, this.totalBlows);
      if (!this.isInfant)
      {
        this.finish('critical');
        return false;
      }
      else if (this.totalBlows !== 5)
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      else
      {
        this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      //console.log('perf', this.performance);
    },

    finalComplete: function()
    {
      this.finish();
    },

    finish: function($performance)
    {
      ScenarioActivity.prototype.finish.apply(this, arguments);
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      this.counterPanel.find('[data-mc=text_tf]').html($sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivityBandage;

});

